import React from 'react';
import moment from 'moment';
import styles from './Time.module.scss';

const Time = ({ startedAt }) => {
    return <span className={styles.time}>{moment.unix(startedAt).format('DD MMM HH:mm')}</span>;
};

export default Time;
